import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { WaterSupplyWorkTypeDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyWorkTypeDataDDL';
import { WaterSupplyWorkNameDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyWorkNameDataDDL';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch, useSelector } from 'react-redux';
import { WaterSupplyWorkNamePostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/WaterSupplyMasterSlice/WaterSupplyWorkNameSlice';
import { WaterSupplyWorkPeriodDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyWorkPeriodDataDDL';


export default function WaterWorkMasterPagePopup(props) {

    const { RoleID, handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, apiFlag, rowData, handleIsPost, WardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [Pipeline, setPipeline] = useState(Flag === 'Update' ? rowData.pipelineDetails : '')
    const [IsOpen, setIsOpen] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [WSWorkType, setWSWorkType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_Distri_WorkTypeID : 0,
        Label: Flag === 'Update' ? rowData.workType : "Select...",
    })

    const [WaterSupplyWorkPeriod, setWaterSupplyWorkPeriod] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_Distri_WorkPeriodID : 0,
        Label: Flag === 'Update' ? rowData.parameterDescription : "Select...",
    })

    const [WSWorkMasterTextField, setWSWorkMasterTextField] = useState({
        workCode: Flag === 'Update' ? rowData.workCode : '',
        workName: Flag === 'Update' ? rowData.workName : '',
        penaltyPeriod: Flag === 'Update' ? rowData.penaltyPeriod : '',
        benchMark: Flag === 'Update' ? rowData.benchMark : '',
        penalty_Description: Flag === 'Update' ? rowData.penalty_Description : '',
        penalty_Values: Flag === 'Update' ? rowData.penalty_Values : ''
    })

    const handleWSWorkMasterTextField = (e) => {
        setWSWorkMasterTextField({ ...WSWorkMasterTextField, [e.target.name]: e.target.value })
    }

    const handleClear = () => {
        setIsClear(!IsClear)
        setPipeline('')
        setWSWorkType({
            ...WSWorkType,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handlePost = () => {

        const data = {
            M_Distri_WorkNameID: Flag === 'Update' ? rowData.m_Distri_WorkNameID : '0',
            M_WS_WorkNameID: Flag === 'Update' ? rowData.m_wS_WorkNameID : '0',
            M_Distri_WorkTypeID: WSWorkType.ID,
            M_Distri_WorkPeriodID: WaterSupplyWorkPeriod.ID,
            WorkCode: WSWorkMasterTextField.workCode,
            WorkName: WSWorkMasterTextField.workName,
            PenaltyPeriod: WSWorkMasterTextField.penaltyPeriod,
            BenchMark: WSWorkMasterTextField.benchMark,
            Penalty_Description: WSWorkMasterTextField.penalty_Description,
            Penalty_Values: WSWorkMasterTextField.penalty_Values,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID

        }
        dispatch(WaterSupplyWorkNamePostDataAPI({ data }))

    }
    const { isPostLoading } = useSelector(state => state.WaterSupplyWorkNamePostData)

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Work Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <WaterSupplyWorkTypeDataDDL
                                        WSWorkType={WSWorkType}
                                        setWSWorkType={setWSWorkType}
                                        Flag={Flag}
                                        rowData={rowData}
                                        DashProjectTypeId={DashProjectTypeId}
                                    />

                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <WaterSupplyWorkPeriodDataDDL
                                        WaterSupplyWorkPeriod={WaterSupplyWorkPeriod}
                                        setWaterSupplyWorkPeriod={setWaterSupplyWorkPeriod}
                                        DashProjectTypeId={DashProjectTypeId}
                                        Flag={Flag}
                                        rowData={rowData}

                                    />

                                </div>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Work Code </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="workCode"
                                            name='workCode'
                                            value={WSWorkMasterTextField.workCode}
                                            onChange={handleWSWorkMasterTextField}
                                        />
                                    </div>
                                </div>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Work Name </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="workName"
                                            name='workName'
                                            value={WSWorkMasterTextField.workName}
                                            onChange={handleWSWorkMasterTextField}
                                        />
                                    </div>
                                </div>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Penalty Period </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="penaltyPeriod"
                                            name='penaltyPeriod'
                                            value={WSWorkMasterTextField.penaltyPeriod}
                                            onChange={handleWSWorkMasterTextField}
                                        />
                                    </div>
                                </div>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Bench Mark </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="benchMark"
                                            name='benchMark'
                                            value={WSWorkMasterTextField.benchMark}
                                            onChange={handleWSWorkMasterTextField}
                                        />
                                    </div>
                                </div>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Penelty Description </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="penalty_Description"
                                            name='penalty_Description'
                                            value={WSWorkMasterTextField.penalty_Description}
                                            onChange={handleWSWorkMasterTextField}
                                        />
                                    </div>
                                </div>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Penelty Amount(Rs)</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="penalty_Values"
                                            name='penalty_Values'
                                            value={WSWorkMasterTextField.penalty_Values}
                                            onChange={handleWSWorkMasterTextField}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-12 pt-md-4 pt-4">
                                <div className="btn-action d-flex justify-content-end ">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost())}
                                    // disabled={
                                    //     JunctionNameDDL.ID == 0 || Pipeline == ''
                                    // }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}